// extracted by mini-css-extract-plugin
module.exports = {"brandedSearchPageCollection":"BrandedSearchPageCollection_brandedSearchPageCollection__GM5z1","brandedSearchHeader":"BrandedSearchPageCollection_brandedSearchHeader__jhUfZ"};